import SvgIntensity_1 from '@sats-group/icons/16/intensity-1';
import SvgIntensity_2 from '@sats-group/icons/16/intensity-2';
import SvgIntensity_3 from '@sats-group/icons/16/intensity-3';
import Tag from '@sats-group/ui-lib/react/tag/tag';
import type { Tag as TagProps } from '@sats-group/ui-lib/react/tag/tag.types';
import React, { type ReactSVGElement } from 'react';
import { mod } from '~/client/helpers/add-bem-modifiers';
import type { ClubLoadIndicator as Props } from './club-load-indicator.types';
import { themes } from './club-load-indicator.types';

const loadLevels: Record<
  number,
  {
    Icon: () => ReactSVGElement;
    variant: NonNullable<TagProps['variant']>;
  }
> = {
  0: { Icon: SvgIntensity_1, variant: Tag.variants.positive },
  1: { Icon: SvgIntensity_2, variant: Tag.variants.attention },
  2: { Icon: SvgIntensity_3, variant: Tag.variants.negative },
};

const maxLoad = Math.max(...Object.keys(loadLevels).map(Number));

const ClubLoadIndicator: React.FC<Props> & { themes: typeof themes } = ({
  loadFactor = {},
  loadTexts = {},
  tagTheme,
  theme,
}) => {
  // NOTE: We don't show the load if the props specify a different range than this component, because that would be lying.
  const currentLoad =
    typeof loadFactor.current === 'number' && loadFactor.max === maxLoad
      ? loadFactor.current
      : undefined;

  if (currentLoad === undefined) {
    return null;
  }

  const loadLevel = loadLevels[currentLoad];

  if (loadLevel === undefined || loadTexts[currentLoad] === undefined) {
    return null;
  }

  const { Icon, variant } = loadLevel;

  return (
    <div className={mod('club-load-indicator', theme)}>
      <Tag
        border
        icon={<Icon />}
        size={Tag.sizes.s}
        text={loadTexts[currentLoad]}
        variant={variant}
        theme={tagTheme}
      />
    </div>
  );
};

ClubLoadIndicator.themes = themes;

export default ClubLoadIndicator;
